<ol>
  @for (item of dataSignal(); track $index; let last = $last;){
  <li class="w-full" [ngClass]="{ 'line-text': !last }">
    <div class="flex title-about-us">
      <div>{{ $index + 1 }}.&nbsp;</div>
      <div>{{ item.title }}</div>
    </div>

    <ol class="title-about-us">
      @if (item.subtitle?.length) { @for (sub of item.subtitle; track $index) { @if(sub.headers){
      <!-- <li>{{$index+1}}. {{sub.headers}}</li> -->
      <li class="sub-headers title-about-us">{{ sub.headers }}</li>
      } @if (sub.contentHTML) {
      <div class="sub-headers" [innerHTML]="sub.contentHTML"></div>
      } }}
    </ol>
  </li>
  }
</ol>
